<template>
    <div class="detailed">
        <div class="header">
            <div class="flex__between header__top">
                <img :src="head_img_url||''" alt="">
                <div class="flex__null__around">
                    <span class="fs_26 c_80">累计积分</span>
                    <span class="fs_40 c_1a">{{total_integral}}</span>
                </div>
                <div class="flex__null__around">
                    <span class="fs_26 c_80">当前积分</span>
                    <span class="fs_40 c_1a">{{integral}}</span>
                </div>
            </div>
            <!-- nav -->
            <div class="flex__between nav-box">
                <div class="nav__item" v-link="'/Integral/Index'">
                    <img src="@/assets/images/detailed.png" alt="">
                    <div class="flex__null__between nav__item__info">
                        <span class="fs_32 c_ff fw_600 lh_40">积分商城</span>
                        <span class="fs_24 c_ff">前往&ensp;></span>
                    </div>
                </div>
                <div class="nav__item" v-link="'/Integral/Strategy'">
                    <img src="@/assets/images/detailed1.png" alt="">
                    <div class="flex__null__between nav__item__info">
                        <span class="fs_32 c_ff fw_600 lh_40">积分攻略</span>
                        <span class="fs_24 c_ff">前往&ensp;></span>
                    </div>
                </div>
                <div class="nav__item" v-link="'/Integral/Ranking'">
                    <img src="@/assets/images/detailed2.png" alt="">
                    <div class="flex__null__between nav__item__info">
                        <span class="fs_32 c_ff fw_600 lh_40">排行榜</span>
                        <span class="fs_24 c_ff">前往&ensp;></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="list">
             <!-- 选项卡 -->
            <div class="flex__between__center switch-box">
                <div class="flex align-center switch__item" :class="loads.index==index?'active':''" v-for="(item,index) in nav_list" :key="index" @click="loads.index=index">
                    <span class="fs_30" :class="loads.index==index?'c_1a fw_500':'c_66'">{{item.text}}</span>
                </div>
            </div>
            <div class="flex__between__center item" v-for="(item,index) in list" :key="index">
                <div class="flex__null__between">
                    <span class="fs_28 c_1a lh_40">{{item.show_text}}</span>
                    <span class="fs_24 c_98 lh_34 mt_10">{{item.create_time}}</span>
                </div>
                <span class="fs_30 c_1a">{{item.integral}}</span>
            </div>
        </div>
        <jc-list :url="'/Integral/getIntegralDetailList'" :loads="loads" @load='getList'></jc-list>
    </div>
</template>
<script>
export default {
    name:"Detailed",
    data(){
        return {
            list:[],
            total_integral:0,
            integral: 0,
            loads:{
                user_id: localStorage.user_id,
                index: 0
            },
            nav_list:[
                {text:'全部',status: 0},
                {text:'收入',status: 1},
                {text:'支出',status: 2},
            ] 
        }
    },
    methods:{
         getList (data) { 
            this.list=data;
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Integral/getIntegralDetailData',{
            user_id: localStorage.user_id
        }).then(
            res=>{
                this.integral=res.data.data.integral;
                this.total_integral=res.data.data.total_integral;
                this.head_img_url=res.data.data.head_img_url;
            }
        )
    }
}
</script>
<style scoped>
.header{
    padding: 30px;
    background: #fff;
}
.header__top{
    padding: 0 100px 40px 10px;
}
.header__top img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
}
/* nav菜单 */
.nav__item{
    position: relative;
    width: 220px;
    height: 120px;
    border-radius: 10px;
}
.nav__item img{
    position: absolute;
    top: 0;
    left: 0;
    width: 220px;
    height: 120px;
    border-radius: 10px; 
}
.nav__item__info{
    position: absolute;
    top: 0;
    left: 0;
    width: 330px;
    height: 120px;
    padding: 20px 30px;
}
/* 选项卡 */
.switch-box{
    width: 100%;
    height: 90px;
    padding: 0 300px 0 30px;
    background: #fff;
}
.switch__item.active{
    height: 90px;
    border-bottom: 6px solid #F93A42;
}
/* 列表 */
.list{
    margin-top: 15px;
    background: #fff;
}
.item{
    padding: 30px;
    border-bottom: 2px solid #e6e6e6;
}
.item:last-child{
    border: 0;
}
</style>





// WEBPACK FOOTER //
// src/pages/integral/Detailed.vue